import { ACTIONS_FROM_LOCAL_LOGGING } from '../../constants';

const initialWhiteLabelState = {
	enableLocalLog: false
};

const localLogState = (state = initialWhiteLabelState, action) => {
	switch (action.type) {
		case ACTIONS_FROM_LOCAL_LOGGING.SET_LOCAL_LOGGING:
			return {
				...state,
				enableLocalLog: action.enableLocalLog
			};
		default:
			return state;
	}
};

export default localLogState;



// WEBPACK FOOTER //
// ./src/redux/reducers/reducer_localLogging.js